import React from 'react'
import { Select, MenuItem, TextField, Checkbox, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';
import FormField from '../../Components/common-components/form-input';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';



const AddAndFillForm = ({ methods, data,patientDetails,form_List }) => {
    const { fields } = data
    const {
        handleDateChange,
        handleRadioChange,
        handleCheckboxChange,
        handleInputChange,
        handleTextChange,
        handleSubmit
    } = methods
    return (
        <div className='row p-lg-4 p-md-4 p-2 overflow_Scroll' style={{ height: '80vh' }}>
            <div className='col-lg-12 col-md-12 col-12'>
                <div className='d-flex flex-column justify-content-between border h-100 p-3' style={{ background: '#F5F5F5' }}>
                    <div className='row pb-3'>
                        <div className='row page-content pt-2'>
                            {fields?.length > 0 && fields?.map((result, index) => {
                                if (result?.type === 'Text') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'>{result?.required ? "*" : ""}</span></div>
                                                </div>
                                            </div>
                                            <FormField
                                                name={'text'}
                                                value={result?.answer || ""}
                                                onChange={(e) => handleTextChange(e, result.id)}
                                                data={{ label: '', placeholder: '', type: 'text' }} />
                                        </div>
                                    );
                                }
                                if (result?.type === 'Date') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'><span className='text-danger'>{result?.required ? "*" : ""}</span></span></div>
                                                </div>
                                            </div>
                                            <div className="mt-3 col-12 border p-1 rounded bg-body">
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="MM/dd/yyyy"
                                                        value={result?.answer || null}
                                                        onChange={(date) => handleDateChange(date, result?.id)}
                                                        className='col-12 border-none'
                                                        renderInput={(params) => <TextField variant="standard" {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                    );
                                }
                                if (result?.type === 'Multiple Choice') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'>{result?.required ? "*" : ""}</span></div>
                                                </div>
                                            </div>
                                            <FormControl>
                                                <RadioGroup
                                                    value={result?.answer || ""}
                                                    onChange={(e) => handleRadioChange(e, result.id)}>
                                                    {result?.options?.map((val, index) => (
                                                        <FormControlLabel key={index} value={val.id} control={<Radio />} label={val.name} />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    );
                                }
                                if (result?.type === 'CheckBox') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'>{result?.required ? "*" : ""}</span></div>
                                                </div>
                                            </div>
                                            <FormGroup row>
                                                {result?.options?.map((val, index) => (
                                                    <FormControlLabel key={index} control={
                                                        <Checkbox
                                                            checked={result?.answer?.includes(val?.id)}
                                                            onChange={(e) => handleCheckboxChange(e, val, result.id)}
                                                        />} label={val.name} />
                                                ))}
                                            </FormGroup>
                                        </div>
                                    );
                                }
                                if (result?.type === 'Dropdown') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'>{result?.required ? "*" : ""}</span></div>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-3 border rounded bg-body">
                                                <Select
                                                    value={result?.answer || ""}
                                                    onChange={(e) => handleInputChange(e, result.id)}
                                                    variant="outlined"
                                                    className='w-100'
                                                    size='small'>
                                                    {result?.options?.map((val, index) => (
                                                        <MenuItem key={index} value={val.id}>{val.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                    );
                                }
                                if (result?.type === 'Title') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div>{result?.label}<span className='text-danger'>{result?.required ? "*" : ""}</span></div>
                                                </div>
                                            </div>
                                            <FormField
                                                name={'title'}
                                                value={result?.answer || ""}
                                                onChange={(e) => handleTextChange(e, result.id)}
                                                data={{ label: '', placeholder: '', type: 'text' }} />
                                        </div>
                                    );
                                }
                                return null
                            })}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button className="theme-btn bgDarkBlue px-5 mx-2" onClick={()=>handleSubmit(patientDetails?.id,form_List)}>Submit</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AddAndFillForm
